<template>
  <div class="active-search">
    <div class="searchTitle-top-header flex item1">
      <div class="searchTitle-top" >
        <div class="picker-alls van-hairline--right" @click="showPop=!showPop">
          {{pickerName}}
          <div class="triangle_border_down"></div>
        </div>
        <div class="flex input-search-flex item1">
          <input type="text" :placeholder="placeholder" class="search_input item1" v-model="value" @keyup.enter="emit">
          <img :src="require('@/assets/img/search.png')" class="search-img" @click="emit">
        </div>
      </div>
    </div>
    <van-popup v-model="showPop" position="bottom" :overlay="true">
      <van-picker
        show-toolbar
        :columns="pickerList"
        value-key="name"
        @confirm="typeChange"
        @cancel="showPop=!showPop"
      />
    </van-popup>
  </div>

</template>
<script>
    export default{
        data(){
            return {
              showPop:false,
              type:0,
              pickerName:'全部活动',
              value:''
            }
        },
        props:{
          placeholder:{
              type:String,
              default:'活动名称'
          }
        },
        watch:{
          value(newVal,oldVal){
              if(newVal.length>60){
                  this.value = oldVal
              }
          },
          '$route' (to, from) {
            if(from.name == 'Index'){
              this.value = ''
              this.type=0
              this.pickerName='全部活动'
            }
          }
        },
        computed:{
          pickerList:function(){
            return  [
              {
                id:0,
                name:'全部活动'
              },
              {
                id:1,
                name:'我的活动'
              },
              {
                id:2,
                name:'待我审批'
              }
            ]
              console.log(this.$wxuserUtil.getUserObj())
              let userinfo =this.$wxuserUtil.getUserObj()
//              if(this.$wxuserUtil.getUserObj().isDeptDS){
//                  return [
//                    {
//                      id:0,
//                      name:'全部活动'
//                    },
//                    {
//                      id:1,
//                      name:'我的活动'
//                    }
//                  ]
//                this.pickerName='我的活动'
//              }else if(userinfo.isRoleMarketing||userinfo.isRoleRegionalSalesManager){
//                  return  [
//                    {
//                      id:0,
//                      name:'全部活动'
//                    },
//                    {
//                      id:2,
//                      name:'待我审批'
//                    }
//                  ]
//                this.pickerName='待我审批'
//              }else if(userinfo.isRoleSalesDirector){
//                return  [
//                  {
//                    id:0,
//                    name:'全部活动'
//                  },
//                  {
//                    id:1,
//                    name:'我的活动'
//                  },
//                  {
//                    id:2,
//                    name:'待我审批'
//                  }
//                ]
//                this.pickerName='待我审批'
//              }else{
//                return  [
//                  {
//                    id:0,
//                    name:'全部活动'
//                  }
//                ]
//              }
          }
        },
        methods:{
          emit(){
            this.$emit('typesChange',{campType:this.type,campName:this.value})
          },
          typeChange(e){
              this.type=e.id
              this.pickerName=e.name
              this.showPop = !this.showPop
              this.emit()
          }
        }
    }
</script>
<style scoped lang="less" rel="stylesheet/less">
  .active-search .searchTitle-top-header {
    padding: 0.3rem;
    margin: 0;
    background-color:#fff;
    position:fixed;
    top:0;
    left:0;
    width:100%;
    z-index:3;
    box-sizing:border-box;
  .searchTitle-top {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: 1rem;
    align-items: center;
    background: #f6f6f6;
    flex: 1;
    border-radius: 5px;
    over-flow:hidden;

  .input-search-flex {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding-right:10px;
    height: 100%;
  }

  .search_input {
    border: none;
    outline: none;
    background: #f6f6f6;
    padding-left: 0.18rem;
    height: 100%;
  }
  .picker-alls {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 100%;
    padding: 0 0.3rem;
    border-right: 1px solid #f0f0f0;
  }
  .search-img {
    width: 0.5rem;
    height: 0.5rem;
    position: relative;
    top:0.25rem;
  }
  }
  }
</style>



// WEBPACK FOOTER //
// src/components/active/component/activeSearch.vue